import { q, qq } from "../../helper/q"

export const quantityInit = () => {
  const quantityElements = qq(".buyQuantity")
  if (quantityElements) {
    quantityElements.map(quantityElement => {
      const step = parseFloat(q(".buyQuantityLeft", quantityElement).dataset.step)
      const incrementElement = qq(".buyQuantityButton", quantityElement)[0]
      const decrementElement = qq(".buyQuantityButton", quantityElement)[1]
      let value = step
      incrementElement.addEventListener("click", () => {
        value = value + step
        setValue(value)
        setPrice(value)
      })
      decrementElement.addEventListener("click", () => {
        if (value != step) {
          value = value - step
          setValue(value)
          setPrice(value)
        }
      })
    })
  }
}

const setValue = value => {
  const buttons = qq("button[data-productid]")
  const digitElements = qq(".buyQuantityTextDigit")
  buttons.map(button => {
    button.dataset.productquantity = value
  })
  digitElements.map(digitElement => {
    digitElement.innerHTML = value
  })
}

const setPrice = value => {
  const priceElements = qq(".buyValueTotal")
  const quantityElements = qq(".buyValueTotal .buyWeight span")
  quantityElements.map(quantityElement => {
    quantityElement.innerHTML = value
  })
  priceElements.map(priceElement => {
    const price = parseFloat(priceElement.dataset.price)
    q(".buyPriceRouble", priceElement).innerHTML = `${formatPrice(
      value * price,
      0,
      3,
      " ",
      ","
    )} <ruble><span class="text">руб.</span></ruble>`
  })
}

const formatPrice = (number, n, x, s, c) => {
  const re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")"
  const num = number.toFixed(Math.max(0, ~~n))
  return (c ? num.replace(".", c) : num).replace(new RegExp(re, "g"), "$&" + (s || ","))
}
